<ng-container coreActivitySection="GiftCard">
  @let currentLanguage = this.currentLanguage();
  @let isFrench = currentLanguage === 'fr-CA';

  <app-page-header
    class="header"
    (click)="back.emit()"
    coreUserActivityClickTracking="CloseGiftCard"
  />

  <div class="content">
    @if (isFrench) {
      <img
        src="/images/service-center-sections/gift-cards-content-fr.svg"
        width="740"
        height="382"
        alt="Gift Cards Content"
      />
    } @else {
      <img
        src="/images/service-center-sections/gift-cards-content-en.svg"
        width="740"
        height="382"
        alt="Gift Cards Content"
      />
    }
  </div>

  <div class="link">
    @let qrCodeLinkEn = 'https://oon.gl/M2ZBh3';
    @let qrCodeLinkFr = 'https://oon.gl/ZfbLe5';

    <app-qrcode
      class="qr-code"
      variant="red"
      [content]="isFrench ? qrCodeLinkFr : qrCodeLinkEn"
      [size]="400"
    />
  </div>
</ng-container>
